export * from '@fify.at/gatsby-theme-base/src/components/HeroSection/HeroSection.styles';

export const HeroSection = {};
